module.exports = __webpack_public_path__ + "assets/8afa428eb6c1163c5d4b6485d3ad69b7.mp3";